/* ============================================================
   c-facet-open.js
   サイドバー（vertical）のフィルタグループを「常時展開・非開閉」に固定する。
   モック kusu_collection.html の .side-sec はアコーディオンではなく
   常時展開の静的な見出し + リストのため。

   基本の抑止は CSS（c-collection-facets.css）側の
   summary { pointer-events: none } + Liquid 側の tabindex="-1" で行い、
   ここでは「それでも閉じてしまう経路」を塞ぐ:
   - Dawn の onKeyUpEscape（global.js）が Esc キーで details[open] を
     removeAttribute('open') する
   - テーマエディタや他スクリプトからの programmatic な開閉

   details の toggle イベントはバブルしないが、キャプチャ段階は
   document → target と必ず伝播するため、document のキャプチャで拾える。
   これにより facets.js が details の innerHTML を差し替えた後も
   （委譲なので）再バインド不要で効き続ける。

   モバイルドロワー（.mobile-facets__details / 750px 未満）は Dawn 既定の
   開閉のままにするため、.facets__disclosure-vertical だけを対象にする。
   ============================================================ */
(function () {
  'use strict';

  var SELECTOR = '.facets__disclosure-vertical';

  function lock(details) {
    if (!details || details.open) return;
    details.open = true;
    var summary = details.querySelector('summary');
    // onKeyUpEscape が付ける aria-expanded="false" を残さない（常時展開のため）
    if (summary) summary.removeAttribute('aria-expanded');
  }

  function onToggleCapture(event) {
    var target = event.target;
    if (target && target.matches && target.matches(SELECTOR)) lock(target);
  }

  function lockAll() {
    document.querySelectorAll(SELECTOR).forEach(lock);
  }

  document.addEventListener('toggle', onToggleCapture, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', lockAll);
  } else {
    lockAll();
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', lockAll);
  }
})();
